import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

function ZoneDetails() {

    const navigate = useNavigate();
    const location = useLocation();
    const zoneDetails = location.state?.zoneDetails || {};

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/organization-Zone")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                Zone Details of :  {zoneDetails.zone_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Zone Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="zone_name"
                                                        readOnly
                                                        value={zoneDetails.zone_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={zoneDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ZoneDetails
